import _ from 'lodash';
import { productAlias } from './productAlias';
import { kgToSellingUnitQuantity } from './kgToSellingUnitQuantity';

export function lmOrderDescription(fgObject: any): string | undefined {
  if(!fgObject) return;
  const order = _.get(fgObject, 'factoryTicket.order');
  if(!order) return;
  let lmOrderDescription = `Order# ${order._id}`;
  if(order.customerPO) {
    lmOrderDescription = `${lmOrderDescription} / PO# ${order.customerPO}`;
  }
  lmOrderDescription = `${lmOrderDescription} / ${productAlias(order.product)}`;
  const sellingUnitQuantity = kgToSellingUnitQuantity(order, fgObject, _.get(fgObject, 'location.Warehouse.totalQuantity', 0));
  const sellingUnit = _.get(order, 'product.unit.unit2');
  if(sellingUnitQuantity && sellingUnit) {
    lmOrderDescription = `${lmOrderDescription} / ${sellingUnitQuantity} ${sellingUnit}(s)`;
  }
  return lmOrderDescription;
}